import moment from 'moment';

const isoDateFormat = "YYYY-MM-DD";
const defaultTrendDays = 30;
export const maxTrendDays = 366;

export const trendPeriodProblems = {
    tooLong: "tooLong",
    startsAfterToday: "startsAfterToday"
};

// The daily counts are cut at UK-local midnight, so "today" is the date in London, not in the browser's zone.
export function ukToday() {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' }).format(new Date());
}

/**
 * The days the trend covers: the chosen period cut off at today, or the last 30 days when none is chosen.
 * A period the daily counts cannot answer is reported as a problem instead of being read.
 */
export function buildTrendPeriod(from, to) {
    const today = ukToday();

    if (from == null || to == null) {
        return {
            from: moment(today, isoDateFormat).subtract(defaultTrendDays - 1, 'days').format(isoDateFormat),
            to: today,
            problem: null
        };
    }

    const end = to > today ? today : to;
    let problem = null;

    if (from > today) {
        problem = trendPeriodProblems.startsAfterToday;
    } else if (moment(end, isoDateFormat).diff(moment(from, isoDateFormat), 'days') + 1 > maxTrendDays) {
        problem = trendPeriodProblems.tooLong;
    }

    return {
        from: from,
        to: end,
        problem: problem
    };
}
